export default {
    'diagram5': {
      'title': `Please drag and drop the elements of the problem definition into their correct positions in the framework. There may be more than one element for each position`,
      'structure-answers-title': `Elements of the problem definition`,
      'situation-title': 'situation',
      'diagram-header': 'WINTER WHOLESALE GROCERS',
      'top-box-desc-top': 'Supermarkets',
      'top-box-desc-bottom': 'Independents',
      'top-box-points': `
      <ul>
        <li>Order Goods</li>
        <li>Place on Shelves</li>
      </ul>`,
      'left-box': 'Buy for Manufacturers',
      'middle-box': 'Store in Warehouse',
      'right-box': 'Deliver to retail customers',
      'bottom-box-points': `
      <ul>
        <li>Avoid
            <ul>
                <li>Being out of stock</li>
                <li>Having excess inv.</li>
            </ul>
        </li>
        <li>Procurement</li>
        <li>Merchandising</li>
      </ul>
      <ul style="padding-left: 28px;">
        <li>Receive truckload of pallets</li>
        <li>Break pallets into cases, shelve</li>
        <li>Receive order
            <ul style="position: relative; width: max-content;">
                <li>Select & load onto pallet jacks</li>
                <li>Take to outbound shipping</li>
                <li>Shrink wrap and load</li>
            </ul>
        </li>
        <li style="position: relative; width: max-content;">Ship customized case to retailer</li>
      </ul>
      <ul style="position: relative; left: 6px;">
        <li>On Time</li>
        <li style="width: 99px;">Without errors</li>
      </ul>
      `,
      'situation-desc': 'DISTURBING EVENT'
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/5/5b/diagram5/i18n/en.js